export default __webpack_public_path__ + "static/media/shape3.1e0a0d68.svg";